import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25bddbe0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_MenuItem = _resolveComponent("MenuItem")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _ctx.activeIndex,
    class: "menu",
    mode: "horizontal",
    "unique-opened": "",
    router: "",
    "menu-trigger": "hover",
    "active-text-color": "#114cb8",
    onSelect: _ctx.handleSelect
  }, {
    default: _withId(() => [
      _createVNode(_component_el_menu_item, {
        onClick: _ctx.goHome,
        class: "logo-img",
        style: {"border-bottom-color":"rgb(255, 255, 255, 0)"}
      }, null, 8, ["onClick"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.showRoutes(_ctx.allRoutes), (route) => {
        return (_openBlock(), _createBlock(_component_MenuItem, {
          key: route.path,
          item: route
        }, null, 8, ["item"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["default-active", "onSelect"]))
})